'use strict';

// Collection page | Arrow
(function () {
    if (!document.body.classList.contains('template-collection')) return;

    var arrow = document.querySelector('.collection-header__arrow');
    var header = document.querySelector('.SectionHeader__Heading');

    // получаем координаты элемента в контексте документа
    function getCoords(elem) {
        var box = elem.getBoundingClientRect();

        return {
            top: box.top + pageYOffset,
            left: document.documentElement.getAttribute('dir') !== 'rtl' ? box.left + pageXOffset : box.left + box.width
        };
    }
    var cords = getCoords(header);

    arrow.style.top = cords.top + header.offsetHeight + 10 + 'px';
    arrow.style.left = cords.left + 'px';

    var resetBtn = document.querySelector('[data-collection-reset]');

    if (resetBtn.parentElement.parentElement.querySelectorAll('.is-selected').length > 1) {
        resetBtn.classList.remove('is-active');
        resetBtn.parentElement.classList.remove('is-selected');
    }

    resetBtn.addEventListener('click', function () {
        resetBtn.classList.toggle('is-active');
        resetBtn.parentElement.classList.toggle('is-selected');
    });

    if (window.innerWidth > 1440 && window.innerWidth < 1500) {
        var decor = document.querySelectorAll('.CollectionInner__Products__decor');
        decor.forEach(function (shape) {
            shape.style.width = window.innerWidth - shape.getBoundingClientRect().left + 'px';
//             setTimeout(function () {
//               	window.isRTL 
//                 ? shape.style.right = '-80px' 
//                 : shape.style.left = '-80px';
//             }, 0);
        });
    }
})();